import Enum from './enum'

class AdvancePaymentBlockReason extends Enum
{
  constructor(value) {
    super(value);
  }
}

AdvancePaymentBlockReason.init({
  COMBINATION: 'combination',
  RULES: 'rules',
  EMPTY_PART: 'empty-part'
},
{
  COMBINATION: 'advance-payment-block-reason.combination',
  RULES: 'advance-payment-block-reason.rules',
  EMPTY_PART: 'advance-payment-block-reason.empty-part'
});

export default AdvancePaymentBlockReason;
